import { render } from "./TxnPurchaseSummary.vue?vue&type=template&id=5f8cfb86&scoped=true"
import script from "./TxnPurchaseSummary.vue?vue&type=script&lang=js"
export * from "./TxnPurchaseSummary.vue?vue&type=script&lang=js"

import "./TxnPurchaseSummary.vue?vue&type=style&index=0&id=5f8cfb86&scoped=true&lang=css"
import "./TxnPurchaseSummary.vue?vue&type=style&index=1&id=5f8cfb86&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8cfb86"]])

export default __exports__